<div class="ds-form-row investment-box" [class.has-error]="hasError">
  <h4 class="ds-heading-2">{{ title }}</h4>
  <div class="chips">
    <ng-container *ngFor="let chip of chips">
      <app-ds-chip [active]="!showCustomInput && value === chip" [value]="chip" (check)="onCheck($event)">
        {{ chip.toFixed(0) | thousand }}
      </app-ds-chip>
    </ng-container>

    <ng-container *ngIf="savingsPlan">
      <app-ds-chip [active]="value === 0 && !showCustomInput" [value]="0" (check)="onCheck($event)">
        {{ 'GROW.riskProfile.amount.savingsPlan.values.noPlan' | translate }}
      </app-ds-chip>
    </ng-container>

    <ng-container *ngIf="customAmount">
      <app-ds-chip [active]="showCustomInput" (check)="onSelectCustomValue()">
        {{ 'GROW.riskProfile.amount.initialInvestment.values.specifyAmount' | translate }}
      </app-ds-chip>
    </ng-container>
  </div>
  <input
    *ngIf="showCustomInput && editMode"
    #inputEditable
    class="ds-input"
    type="number"
    [ngModel]="value"
    (ngModelChange)="onInput($event)"
    (blur)="editMode = false"
  />
  <input
    *ngIf="showCustomInput && !editMode"
    readonly
    class="ds-input"
    type="text"
    [value]="!value ? '' : (value | thousand)"
    (focus)="enterEditMode()"
  />
  <ng-content></ng-content>
</div>
